module.exports = __webpack_public_path__ + "static/media/Nichwagh-Ridge-bylaws.8eb958ee.pdf";